// extracted by mini-css-extract-plugin
export var downArrow = "_ij-0";
export var infoTooltipIcon = "_ij-3";
export var label = "_ij-1";
export var optionCard = "_ij-4";
export var upArrow = "_ij-2";